/**
 * External dependencies
 */
import React from 'react';
import { Box } from '@towersystems/towersystems-design-system';
import classnames from 'classnames';

/**
 * Internal dependencies
 */
import Annotation from './annotation';
import Content from './content';

/**
 * Style dependencies
 */
import './styles.scss';

const AnnotatedSection = ({ classNames, children }) => {
    const classes = classnames('annotated-section', classNames);
    return <Box className={classes}>{children}</Box>;
};

AnnotatedSection.Annotation = Annotation;
AnnotatedSection.Content = Content;

export default AnnotatedSection;
